// extracted by mini-css-extract-plugin
module.exports = {"minimumScreenWidth":"320px","mobileScreenWidth":"600px","wrapper":"style_wrapper__2BvVS","input":"style_input__2W8Up","label":"style_label__3YMrm"};